import { render, staticRenderFns } from "./GlobalNbCreatedPostsChart.vue?vue&type=template&id=543a7770&scoped=true&"
import script from "./GlobalNbCreatedPostsChart.vue?vue&type=script&lang=js&"
export * from "./GlobalNbCreatedPostsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543a7770",
  null
  
)

export default component.exports